import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAbSDm8C2-x0_dXGRZlMGpp3gJOqrzRnw8",
    authDomain: "productpulse-c4efd.firebaseapp.com",
    projectId: "productpulse-c4efd",
    storageBucket: "productpulse-c4efd.firebasestorage.app",
    messagingSenderId: "799672751453",
    appId: "1:799672751453:web:d26151a5b6632a08ec84b4",
    measurementId: "G-TKYDY6GK0C"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);